<ng-container>
    <div class="grid-3col input-grid-gaps align-items-center">
        <app-select-input
            id="serviceId"
            [form]="form"
            [staticOptions]="store.services()"
            valueKey="id"
            labelKey="name"
        >
            <ng-template #item let-data>
                <div class="flex gap-small">
                    <div
                        class="stripe"
                        [style]="'background-color: ' + data.color + ';'">
                    </div>
                    <div class="flex-column gap-xx-small">
                        <div>
                            {{ data.name }}
                        </div>
                        @if (data.description) {
                            <div class="font-size-x-small text-secondary">
                                {{ data.description }}
                            </div>
                        }
                    </div>
                </div>
            </ng-template>

            <ng-template #selectedItem let-data>
                <div class="flex gap-small">
                    <div class="stripe" [style]="'background-color: ' + data.color + ';'"></div>
                    <div>{{ data.name }}</div>
                </div>
            </ng-template>
        </app-select-input>

        <app-select-input
            id="workplaceId"
            [form]="form"
            [staticOptions]="$any(store.workplaces())"
            valueKey="id"
            labelKey="name"
            [showClear]="true">
        </app-select-input>
        <app-date-scroller-input
            [form]="form"
            id="dateFrom"
            endDateId="dateTo"
            [period]="TimePeriodEnum.Month"
            [enablePeriodChange]="true"
            class="mx-auto"
        ></app-date-scroller-input>
    </div>
    <app-table
        [gridData]="$any(store.gridData())"
        [columns]="columns"
        translatePrefix="tools.missingProcedures."
        [hideCheckboxes]="true"
        [additionalFilter]="filters"
        [refreshCallback]="filters.length? store.api.getMissingProcedures : null"
        [refreshCallbackFragment]="toolMissingProceduresFrag"
        [defaultSorters]="[{ column: 'date', direction: 'ASC' }]"
    >
        <ng-template pTemplate="createVisit80090" let-item="item">
            <app-button
                styleClass="p-button-set-icon-size"
                icon="pi-plus"
                [text]="true"
                (clickEvent)="openCreateVisit(item, '80090')"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="createVisit80091" let-item="item">
            <app-button
                styleClass="p-button-set-icon-size"
                icon="pi-plus"
                [text]="true"
                (clickEvent)="openCreateVisit(item, '80091')"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="generalGroups" let-item="item">
            <div class="flex flex-column gap-xxx-small">
                @for (group of item.folder?.activeGroups; track group.id) {
                    <span>{{ group.group.name }}</span>
                }
            </div>
        </ng-template>

        <ng-template pTemplate="visitsThisDay" let-item="item">
            @if (!item.works.length) {
                <div>{{ 'no' | translate }}</div>
            }
            @for (work of item.works; track work) {
                <div>
                    <app-button
                        label="{{ work.dateFrom | date: 'H:m' }} - {{ work.users[0] | formatPerson }}"
                        [text]="true"
                        (clickEvent)="openWorkDetail(work)"
                    ></app-button>
                </div>
            }
        </ng-template>

    </app-table>
</ng-container>
